import { Component, HostListener, input, output } from '@angular/core';
import { Adesao } from '../../../core/models/adesao.model';
import { formatDateIsoToBr } from '../../../core/utils/date-format.util';

@Component({
  selector: 'app-protocolo-log-dialog',
  imports: [],
  templateUrl: './protocolo-log-dialog.component.html',
  styleUrl: './protocolo-log-dialog.component.scss',
})
export class ProtocoloLogDialogComponent {
  readonly adesao = input.required<Adesao>();

  readonly close = output<void>();

  onClose(): void {
    this.close.emit();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.onClose();
  }

  formatProtocoloData(value: string | null | undefined): string {
    if (!value) {
      return '—';
    }

    return formatDateIsoToBr(value.slice(0, 10));
  }
}
